export default "__VITE_ASSET__DRDaymzR__"